import env from '@/config/env'

export const getApkVersion = () => {
  return fetch(`${env.portal}/api/v1/xunmengtu_android/versions`).then(res => res.json())
}